// extracted by mini-css-extract-plugin
export default {"card":"styles_card__x+TAi","container":"styles_container__VdJ-2"};